import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { AddIcon } from 'cokitchen-icons';
import { ReactComponent as CokitchenIcon } from 'assets/icons/cokitchen.svg';
import React, { useState } from 'react';
import { FOOD_CREATE_LIST, SHOP_CREATE_LIST } from 'utils/constants';
import { Link } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import { ENUM_CATEGORY } from 'utils/enum';

const CreateList = () => {
  const { setShowMobileSidebar, category, permissions } = useDashboardContext();
  const [show, setShow] = useState(false);
  const CREATE_LIST = category === ENUM_CATEGORY.FOOD ? FOOD_CREATE_LIST : SHOP_CREATE_LIST;
  const showBtn = permissions.canAccessCreateList;
  if (!showBtn) return <></>;
  return (
    <Dropdown
      placement='bottom'
      visible={show}
      onClickOutside={() => setShow(false)}
      content={
        <div
          onClick={() => setShow(!show)}
          className='cursor-pointer flex items-center rounded-[40px] py-[6px] lg:py-3 px-6 gap-1 bg-gray-14 hover:bg-red-1 transition-all'>
          <AddIcon className='w-5 h-5' />
          Create
        </div>
      }>
      <DropdownList className='min-h-fit'>
        {CREATE_LIST.map(({ link, emoji, name }, i) => (
          <Link
            onClick={() => {
              setShowMobileSidebar(false);
              setShow(false);
            }}
            to={link}
            key={i}>
            <DropdownItem buttonClassName='py-[6px]'>
              {emoji ? (
                <span className='mr-2 p-1 w-[26px] h-[26px] rounded-full border border-gray-13 '>
                  {emoji}
                </span>
              ) : (
                <div className='w-[26px] h-[26px] rounded-full border border-[#EAEAEB] flex justify-center items-center mr-2 p-1'>
                  <CokitchenIcon />
                </div>
              )}

              {name}
            </DropdownItem>
          </Link>
        ))}
      </DropdownList>
    </Dropdown>
  );
};

export default CreateList;
